import { CommonModule } from '@angular/common';
import { Component, ElementRef, EventEmitter, forwardRef, Input, OnChanges, OnInit, Output, Renderer2, ViewChild } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { getRandomId } from '@lib/core';
import { SideEnum } from 'libs/core/src/lib/enum/side.enum';

@Component({
  selector: 'app-radio',
  templateUrl: './radiobutton.component.html',
  providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => RadioButtonComponent), multi: true }],
  standalone: true,
  imports: [CommonModule]
})
export class RadioButtonComponent implements ControlValueAccessor {
  @Input() disabled: boolean = false;
  @Input() set checked(value: boolean) {
    this.isChecked = value;
  }

  @Input() groupName: string;
  @Input() id: string;
  @Input() value: any;
  @Input() side: SideEnum = SideEnum.LEFT;
  @Input() cssClass = 'radio-container';

  @Input() ariaLabel?: string;
  @Input() ariaDescribedby?: string;

  inputId: string;

  @Output() changed = new EventEmitter<boolean>();

  sideEnum: typeof SideEnum = SideEnum;

  isChecked: boolean = false;

  ngOnInit() {
    this.inputId = this.id ? `radio-${this.id}` : `radio-${getRandomId()}`;

    if (!this.groupName) {
      console.warn('Radio button should have a groupName for proper accessibility');
    }
  }

  private onChange: (event: any) => void = () => {};
  private onTouched: () => void = () => {};

  writeValue(obj: any): void {
    this.isChecked = obj === this.value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onRadioChange(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.checked) {
      this.onChange(this.value);
      this.changed.emit(this.value);
    }
    this.onTouched();
  }
}
